import { DatasetChartProps, LagLeadLoadingConfig, LineEditorLoadingTypes } from "../charts/interfaces";

export enum LoadConfigUnitTypes {
  LAGUNIT = "lagUnit",
  LEADUNIT = "leadUnit",
  ALIGNUNIT = "alignUnit",
}

export const defaultLoadConf: LagLeadLoadingConfig = {
  type: LineEditorLoadingTypes.TIME,
  lead: 0,
  lag: 6,
  leadUnit: "HOURS",
  lagUnit: "HOURS",
  alignUnit: "MINUTES",
};

export const defaultDatasetLineChartConfig: DatasetChartProps = {
  title: "",
  xAxisType: "date",
  height: 400,
  showDateSelection: true,
  hideRefresh: false,
  loadConf: defaultLoadConf,
  updateFrequency: 5,
  datasets: [],
  toggleTracesGrouping: true,
  timeAxisStepSeconds: 0,
};
